<p-toast
  key="global"
  position="top-right"
  [baseZIndex]="100000"
  [style]="{ 'font-size': 'x-large' }"
  [breakpoints]="{'920px': { width: '100%', right: '0', left: '0' }}"
  [showTransformOptions]="'translateY(100%)'"
  [showTransitionOptions]="'300ms ease-out'"
  [hideTransitionOptions]="'250ms ease-in'">
</p-toast>
<p-toast position="bottom-center" key="form-sample-v3" (onClose)="onReject()" [baseZIndex]="5000">
    <ng-template let-message #message>
        <div class="custom-toast">
            <i *ngIf="message.severity === 'success'" class="pi pi-check-circle toast-icon success-icon"></i>
            <i *ngIf="message.severity === 'error'" class="pi pi-times-circle toast-icon error-icon"></i>
            <i *ngIf="message.severity === 'warn'" class="pi pi-exclamation-triangle toast-icon warn-icon"></i>
            <i *ngIf="message.severity === 'info'" class="pi pi-info-circle toast-icon info-icon"></i>
            <i *ngIf="!message.severity" class="pi pi-bell toast-icon default-icon"></i>

            <div class="toast-content">
                <div class="toast-header">
                    <span>{{ message.summary }}</span>
                </div>
                <div class="toast-detail">
                    {{ message.detail }}
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<router-outlet>
    @if (configService.configError) {
        <div class="config-error-overlay">
            <div class="error-card">
                <div class="error-icon">
                    <i class="pi pi-exclamation-triangle"></i>
                </div>
                <h2>Error de Configuración</h2>
                <p>No se pudo cargar la configuración del sistema.</p>
                <button pButton label="Reintentar conexión" icon="pi pi-refresh" (click)="reloadPage()"></button>
            </div>
        </div>
    }

    <div *ngIf="configService.appSettings?.general?.licence?.active === false"
        style="position:fixed; bottom: 0;z-index: 999; background-color: orange; color: white; width: 230px;">
        Versión de prueba
    </div>
    <app-loading *ngIf='isLoading'></app-loading>
</router-outlet>
<p-toast [baseZIndex]="100000"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-onboarding-tour></app-onboarding-tour>
